import appDownloadedImage from "../assets/images/appDownloaded.png";

// error image preview when can't found image
export const errorImage = "https://i.imgur.com/Cx6rjiB.png";

// price from app image
export const priceFromAppImage = appDownloadedImage;

// supplier keyAccount image
export const verifiedSupplierBadge =
  "https://cdn.cdnlogo.com/logos/t/77/twitter-verified-badge.svg";

// mechanic app id in sales users ids
export const MECHANIC_APP_AGENT_ID = 17;

// order status
export const REGISTERED = "registered";

export const PRICED = "priced";

export const ACCEPTED = "accepted";

export const FULFILLED = "fulfilled";

export const CANCELLED = "cancelled";

// item status
export const PICKED_UP = "picked_up";

export const NOT_AVAILABLE = "not_available";

export const SOLD = "sold";

export const RETURNED = "returned";

// item price status for mechanic app
export const PRICE_ACCEPTED = "accepted";

export const PRICE_REJECTRD = "rejected";

// item price source
export const PRICING_SOURCE = {
  WEB: "web",
  APP: "app",
  SYSTEM: "system",
  PRICE_LIST: "price_list",
};

// headline types
export const PRIMARY_HEADLINE = "PRIMARY_HEADLINE";
export const SUCCESS_HEADLINE = "SUCCESS_HEADLINE";
export const DANGER_HEADLINE = "DANGER_HEADLINE";
export const WARNING_HEADLINE = "WARNING_HEADLINE";

export const TAX_PERCENTAGE = 0.14;

export const LAT_LNG_REGEX = /^([-+]?(\d*\.\d+|\d+)),\s?([-+]?(\d*\.\d+|\d+))$/;

export const GOOGLE_MAP_LINK_LAT_LNG_REGEX = /@(-?\d+\.\d+),(-?\d+\.\d+)/;

export const GOOGLE_MAPS_LINK_REGEX = /https:\/\/www\.google\.com\/maps\//;

export const WEEK_DAYS_OPTIONS = [
  { label: "Saturday", value: "Saturday" },
  { label: "Sunday", value: "Sunday" },
  { label: "Monday", value: "Monday" },
  { label: "Tuesday", value: "Tuesday" },
  { label: "Wednesday", value: "Wednesday" },
  { label: "Thursday", value: "Thursday" },
  { label: "Friday", value: "Friday" },
];

export const WEB_PORTALS = Object.freeze({
  DASHBOARD: "dashboard",
  SUPPLIER_WEBSITE: "supplier_website",
});

export const STATUS = Object.freeze({
  CANCELLED: "cancelled",
});
